import { HelmetDexteel, useUserContext } from "@dexteel/mesf-core";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { WorkOrdersProvider } from "./context/workOrdersContext";
import { useInitialValues } from "./filters/hooks/useInitialValues";
import WorkOrders from "./WorkOrders";

type Props = {};

const WorkOrdersPage = (props: Props) => {
	const navigate = useNavigate();
	const location = useLocation();
	const { AssetIdParam } = useParams();
	const {
		state: { defaultAreaId },
	} = useUserContext();

	useInitialValues();

	// A missing or non-numeric asset ("null" from a load before the user context) means no asset yet
	const hasValidAssetParam =
		!!AssetIdParam && Number.isInteger(Number(AssetIdParam));

	if (!hasValidAssetParam) {
		if (defaultAreaId === null || defaultAreaId === undefined) {
			return null;
		}
		navigate(
			{ pathname: `/work-orders/${defaultAreaId}`, search: location.search },
			{ replace: true },
		);
		return null;
	}

	return (
		<>
			<HelmetDexteel title="Work Orders" />
			<WorkOrdersProvider>
				<WorkOrders />
			</WorkOrdersProvider>
		</>
	);
};

export default WorkOrdersPage;
